(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8623],{

/***/ 73073:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutus",
      function () {
        return __webpack_require__(48172);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VisibilitySensorComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./components/CountUp.tsx


const CountUpComp = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        duration: 0.4,
        end: end,
        redraw: true,
        suffix: suffix || "",
        enableScrollSpy: true,
        separator: ","
    });
};
/* harmony default export */ var CountUp = (CountUpComp);

;// CONCATENATED MODULE: ./components/VisibilitySensorComponent.tsx



const VisibilitySensorComponent = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            partialVisibility: true,
            offset: {
                bottom: 10,
                top: 10
            },
            children: ({ isVisible  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountUp, {
                        end: end,
                        suffix: suffix
                    }) : end
                })
        })
    });
};
/* harmony default export */ var components_VisibilitySensorComponent = (VisibilitySensorComponent);


/***/ }),

/***/ 48172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ aboutus; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/Aboutus.module.scss
var Aboutus_module = __webpack_require__(99386);
var Aboutus_module_default = /*#__PURE__*/__webpack_require__.n(Aboutus_module);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./components/Recognition.tsx
var Recognition = __webpack_require__(79767);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./styles/history.module.scss
var history_module = __webpack_require__(65421);
var history_module_default = /*#__PURE__*/__webpack_require__.n(history_module);
;// CONCATENATED MODULE: ./components/Historyabtus.tsx







const HistoryAbt = ({ data  })=>{
    const { 0: currentSlide , 1: setCurrentSlide  } = (0,react.useState)(data[0]);
    const { 0: pastSlides , 1: setPastSlides  } = (0,react.useState)([]);
    const { 0: futureSlides , 1: setFutureSlides  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const pastHistory = data.filter((element)=>currentSlide.id > element.id);
        setPastSlides(pastHistory);
        const futureHistory = data.filter((element)=>currentSlide.id < element.id);
        setFutureSlides(futureHistory);
    }, [
        currentSlide
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "history-about",
            className: (history_module_default()).history,
            children: [
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Brief History"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (history_module_default()).arowbt,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (history_module_default()).arowbtalign,
                            onClick: ()=>{
                                if (pastSlides.length > 0) {
                                    setCurrentSlide(pastSlides[pastSlides.length - 1]);
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/new-images/rb-right-a.svg",
                                width: 48,
                                height: 48,
                                alt: "RB-left",
                                className: pastSlides.length > 0 ? (history_module_default()).hoverClass : (history_module_default()).hideClass
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: ()=>{
                                if (futureSlides.length > 0) {
                                    setCurrentSlide(futureSlides[0]);
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/new-images/rb-right-a.svg",
                                width: 48,
                                height: 48,
                                alt: "RB-right",
                                className: futureSlides.length > 0 ? (history_module_default()).hoverClass : (history_module_default()).hideClass
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "history-container",
                    className: (history_module_default()).hstoryContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 8,
                                    className: (history_module_default()).containera,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: currentSlide.year
                                        }),
                                        pastSlides.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (history_module_default()).item,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: pastSlides[pastSlides.length - 1].year
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 8,
                                    className: (history_module_default()).container,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(history_module_default()).item} ${(history_module_default()).histactive}`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: currentSlide.year
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (history_module_default()).brifHist,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: currentSlide.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: currentSlide.imageUrl,
                                                                width: 370,
                                                                height: 235,
                                                                alt: "EdTech3"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        futureSlides.length > 0 && futureSlides.map((slide)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (history_module_default()).item,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: slide.year
                                                })
                                            });
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Historyabtus = (HistoryAbt);

// EXTERNAL MODULE: ./components/VisibilitySensorComponent.tsx + 1 modules
var VisibilitySensorComponent = __webpack_require__(54820);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Ratio.js
var Ratio = __webpack_require__(84883);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
;// CONCATENATED MODULE: ./components/AboutUs.tsx


















const AboutUs = (props)=>{
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    dots: false
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Aboutus_module_default()).edtech,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Aboutus_module_default()).breadcrum,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 7,
                                    md: 10,
                                    xs: 12,
                                    className: (Aboutus_module_default()).centered,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                    style: {
                                                        opacity: 0.5
                                                    },
                                                    href: "/",
                                                    children: "Home"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                    href: "",
                                                    children: " About Us "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "abttop-content",
                                            className: (Aboutus_module_default()).abttopContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: "We are the fastest growing EdTech brand"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Aboutus_module_default()).abttopContentMobile,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                        children: [
                                                            "We help international students and recruitment partners choose the best that global universities offer",
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "parent-mainImg",
                                                className: (Aboutus_module_default()).parentMain,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Aboutus_module_default()).first,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (Aboutus_module_default()).videoPanel,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Aboutus_module_default()).videoPlaceholder,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratio/* default */.Z, {
                                                                    aspectRatio: "16x9",
                                                                    className: (Aboutus_module_default()).customVideoHeight,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                                                        tag: "embed",
                                                                        type: "image/svg+xml",
                                                                        src: props.aboutusData?.video?.videoLink
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Aboutus_module_default()).second,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Aboutus_module_default()).childa,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: props.aboutusData?.secondImage || "/edtech2.svg",
                                                                    alt: props.aboutusData?.secondImageAltTag || "",
                                                                    width: 370,
                                                                    height: 195
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Aboutus_module_default()).childa,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: props.aboutusData?.thirdImage || "/edtech3.svg",
                                                                    alt: props.aboutusData?.thirdImageAltTag || "",
                                                                    width: 370,
                                                                    height: 195
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        id: "our-visiontxtImg",
                        className: (Aboutus_module_default()).rowPadding,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                sm: 2,
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: props.aboutusData?.visionImage?.imageUrl,
                                    width: 133,
                                    height: 120,
                                    alt: props.aboutusData?.visionImage?.alt
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                sm: 10,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (Aboutus_module_default()).subHeading,
                                        children: "Our Vision"
                                    }),
                                    props.aboutusData?.vision
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        id: "our-missiontxtImg",
                        className: (Aboutus_module_default()).rowPadding,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                sm: 2,
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: props.aboutusData?.missionImage?.imageUrl,
                                    width: 133,
                                    height: 120,
                                    alt: props.aboutusData?.missionImage?.alt
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                sm: 10,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (Aboutus_module_default()).subHeading,
                                        children: "Our Mission"
                                    }),
                                    props.aboutusData?.mission
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        id: "our-storytxtImg",
                        className: (Aboutus_module_default()).rowPadding,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                sm: 2,
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: props.aboutusData?.storyImage?.imageUrl,
                                    width: 133,
                                    height: 120,
                                    alt: props.storyImage?.missionImage?.alt
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                sm: 10,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (Aboutus_module_default()).subHeading,
                                        children: "Our Story"
                                    }),
                                    props.aboutusData?.story
                                ]
                            })
                        ]
                    })
                ]
            }),
            props.aboutusData?.history?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Aboutus_module_default()).histbg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Historyabtus, {
                                data: props.aboutusData?.history
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "brief-history",
                                className: (Aboutus_module_default()).briefHistory,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Aboutus_module_default()).containBg,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 4,
                                                lg: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Aboutus_module_default()).historySec,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: (Aboutus_module_default()).foundedIn,
                                                            children: props.aboutusData?.foundedYear
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: "Founded In"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 4,
                                                lg: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Aboutus_module_default()).historySec,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                            className: (Aboutus_module_default()).tieups,
                                                            style: {
                                                                display: "flex",
                                                                justifyContent: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilitySensorComponent/* default */.Z, {
                                                                    end: props.aboutusData?.noOfUniversities
                                                                }),
                                                                "+"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: "Global University Tie-ups"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 4,
                                                lg: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Aboutus_module_default()).historySec,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                            className: (Aboutus_module_default()).studplaced,
                                                            style: {
                                                                display: "flex",
                                                                justifyContent: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilitySensorComponent/* default */.Z, {
                                                                    end: props.aboutusData?.studentsPlaced
                                                                }),
                                                                "+"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: "Students Assisted"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "our-leadership",
                                className: (Aboutus_module_default()).ourleadership,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (Aboutus_module_default()).mainTitle,
                                        children: props.aboutusData?.leadershipTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "d-flex justify-content-center",
                                        children: props.aboutusData?.founderCards?.length > 0 && props.aboutusData?.founderCards.map((card)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                    className: (Aboutus_module_default()).leaderFirst,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: card.linkedinUrl || "/",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Aboutus_module_default()).lindin,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: "/new-images/linkedin.svg",
                                                                    width: 48,
                                                                    height: 48,
                                                                    alt: "EdTech1"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: card.imageUrl,
                                                            height: 373,
                                                            width: 400,
                                                            layout: "responsive",
                                                            alt: card.imageAltTag,
                                                            className: (Aboutus_module_default()).leaderImg
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                                    className: (Aboutus_module_default()).subTitle,
                                                                    children: card.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                                                    className: (Aboutus_module_default()).cardSmalltext,
                                                                    children: card.position
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, card.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: props.aboutusData?.otherLeaders?.length > 0 && props.aboutusData?.otherLeaders.map((card)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xs: 12,
                                                md: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                    className: (Aboutus_module_default()).cardCust,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: card.linkedinUrl || "/",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Aboutus_module_default()).lindin,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: "/new-images/linkedin.svg",
                                                                    width: 48,
                                                                    height: 48,
                                                                    alt: "EdTech1"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: card.imageUrl,
                                                            height: 250,
                                                            width: 250,
                                                            layout: "responsive",
                                                            alt: card.imageAltTag,
                                                            className: (Aboutus_module_default()).leaderImg
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                                    className: (Aboutus_module_default()).subTitle,
                                                                    children: card.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                                                    className: (Aboutus_module_default()).cardSmalltext,
                                                                    children: card.position
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, card.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Aboutus_module_default()).recongnitionMain,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Recognition/* default */.Z, {
                    bgColor: "FBBFB6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "partner-main",
                className: (Aboutus_module_default()).partnerMain,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (Aboutus_module_default()).mainTitle,
                            children: props.aboutusData?.partnerWithTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: props.aboutusData?.partnerWithUs.map((partner, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    lg: 4,
                                    className: (Aboutus_module_default()).partnerSection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Aboutus_module_default()).partnerImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: partner.imageUrl,
                                                        width: 105,
                                                        height: 76,
                                                        alt: partner.imageAltTag
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: partner.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: partner.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: partner.link.href,
                                                className: (Aboutus_module_default()).viewMore,
                                                children: [
                                                    partner.link.label,
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "our-offices",
                className: (Aboutus_module_default()).purplebgOurOffices,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (Aboutus_module_default()).mainTitle,
                            children: " Our Offices"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-none d-sm-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: props.aboutusData.officesKc.map((office, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            md: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                className: (Aboutus_module_default()).cardCustOff,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                            children: office.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: office.address
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (Aboutus_module_default()).info,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (Aboutus_module_default()).contactImg,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/new-images/phone-icon.svg",
                                                                                width: 38,
                                                                                height: 18,
                                                                                alt: "phoneIco",
                                                                                className: (Aboutus_module_default()).icon,
                                                                                objectFit: "contain"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: office.mobile
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (Aboutus_module_default()).info,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (Aboutus_module_default()).contactImg,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/new-images/email-icon.svg",
                                                                                width: 45,
                                                                                height: 18,
                                                                                alt: "emailIco",
                                                                                className: (Aboutus_module_default()).icon,
                                                                                objectFit: "contain"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: office.email
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "/contact-us",
                                            className: (Aboutus_module_default()).viewMore,
                                            children: [
                                                "Explore",
                                                " "
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-block d-sm-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                    ...settings,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: props.aboutusData.officesKc.map((office, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: 12,
                                                    md: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                        className: (Aboutus_module_default()).cardCustOff,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                            className: (Aboutus_module_default()).crdbody,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                                    className: (Aboutus_module_default()).carsubTitle,
                                                                    children: office.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: office.address
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (Aboutus_module_default()).info,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Aboutus_module_default()).contactImg,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                        src: "/new-images/phone-icon.svg",
                                                                                        width: 38,
                                                                                        height: 18,
                                                                                        alt: "phoneIco",
                                                                                        className: (Aboutus_module_default()).icon
                                                                                    })
                                                                                }),
                                                                                office.mobile
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (Aboutus_module_default()).info,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (Aboutus_module_default()).contactImg,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                        src: "/new-images/email-icon.svg",
                                                                                        width: 45,
                                                                                        height: 18,
                                                                                        alt: "emailIco",
                                                                                        className: (Aboutus_module_default()).icon
                                                                                    })
                                                                                }),
                                                                                office.email
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "/contact-us",
                                            className: (Aboutus_module_default()).viewMore,
                                            children: [
                                                "Explore",
                                                " "
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Aboutus_module_default()).purpleSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "learn-abtkcedu",
                    className: (Aboutus_module_default()).LearnAbtKcEdu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (Aboutus_module_default()).mainTitle,
                                children: props.aboutusData?.learnMoreTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: props.aboutusData?.learnMore?.length > 0 && props.aboutusData?.learnMore.map((learn, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: 12,
                                        md: 4,
                                        lg: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Aboutus_module_default()).learnText,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Aboutus_module_default()).iconSetting,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: learn.imageUrl,
                                                            width: 130,
                                                            height: 130,
                                                            alt: learn.imageAltTag
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: learn.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: learn.description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: learn.link.href,
                                                    className: (Aboutus_module_default()).viewMore,
                                                    children: [
                                                        learn.link.label,
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            }),
            props.aboutusData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.aboutusData.faq
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                id: "testimonials",
                                className: (Aboutus_module_default()).testimonialbg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                    className: (Aboutus_module_default()).cardBody,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: (Aboutus_module_default()).rowPaddingBot,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                sm: 2,
                                                md: 3,
                                                xs: 12,
                                                className: (Aboutus_module_default()).imgFixedBottom,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props.aboutusData?.ceoImageUrl,
                                                    width: 186,
                                                    height: 186,
                                                    alt: props.aboutusData?.ceoImageAltTag
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                sm: 10,
                                                md: 9,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Aboutus_module_default()).uptag,
                                                    children: [
                                                        props.aboutusData?.ceoMessage,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (Aboutus_module_default()).smalltext,
                                                            children: "- Pankaj Agrawal, Co-Founder & CEO"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_AboutUs = (AboutUs);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/aboutus.tsx




const Aboutus = (props)=>{
    const { meta  } = props?.aboutusData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AboutUs, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var aboutus = (Aboutus);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 99386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"abttopContent":"Aboutus_abttopContent__FuN5q","abttopContentMobile":"Aboutus_abttopContentMobile__WGGAV","abttopContentdesk":"Aboutus_abttopContentdesk__usTG8","edtech":"Aboutus_edtech__bRG9O","parentMain":"Aboutus_parentMain__GOQmI","first":"Aboutus_first__iQeI5","second":"Aboutus_second__Jwd_N","childa":"Aboutus_childa__SeSoU","videoPanel":"Aboutus_videoPanel__6pkCb","videoBase":"Aboutus_videoBase__xBOp6","videoPlaceholder":"Aboutus_videoPlaceholder__xMQaF","customVideoHeight":"Aboutus_customVideoHeight__9Y7cP","cardTestStu":"Aboutus_cardTestStu__eQFLM","uptag":"Aboutus_uptag__5Awx_","smalltext":"Aboutus_smalltext__lSOGl","breadcrum":"Aboutus_breadcrum__g5chk","enquirebtn":"Aboutus_enquirebtn__vU0yx","heading":"Aboutus_heading__7Bzez","buttongp":"Aboutus_buttongp__mlHFF","kcbtn":"Aboutus_kcbtn__fpxf7","centered":"Aboutus_centered__vGRy1","breadcrumb-item":"Aboutus_breadcrumb-item__I_XGv","active":"Aboutus_active__ztmxJ","mainTitle":"Aboutus_mainTitle__c5HiV","rowPadding":"Aboutus_rowPadding__5DrFQ","rowPaddingBot":"Aboutus_rowPaddingBot__uLYUA","purpleSection":"Aboutus_purpleSection__rp_7I","purplebgOurOffices":"Aboutus_purplebgOurOffices__InH9x","recogTg":"Aboutus_recogTg__TvOx7","recogMob":"Aboutus_recogMob__kCB9K","contanertop":"Aboutus_contanertop__372XK","whiteTxt":"Aboutus_whiteTxt__2797y","briefHistory":"Aboutus_briefHistory__aj_6R","containBg":"Aboutus_containBg__DCdxC","historySec":"Aboutus_historySec__8okUk","foundedIn":"Aboutus_foundedIn__bWxt6","tieups":"Aboutus_tieups__UYYkw","studplaced":"Aboutus_studplaced__7FoF3","ourleadership":"Aboutus_ourleadership__KGklR","subTitle":"Aboutus_subTitle__TjLC8","cardSmalltext":"Aboutus_cardSmalltext__YLjd4","cardCust":"Aboutus_cardCust___me1s","lindin":"Aboutus_lindin__qx4od","leaderImg":"Aboutus_leaderImg___9S6_","leaderFirst":"Aboutus_leaderFirst__TEdYx","card-img":"Aboutus_card-img__27Qh5","card-img-bottom":"Aboutus_card-img-bottom__eqUHO","card-img-top":"Aboutus_card-img-top__aJBaE","partnerMain":"Aboutus_partnerMain__5vgr2","partnerImg":"Aboutus_partnerImg__Q1Ytr","partnerSection":"Aboutus_partnerSection__TgF_c","row":"Aboutus_row__Z_xxg","cardCustOff":"Aboutus_cardCustOff__s4Z6P","info":"Aboutus_info__pnDkR","contactImg":"Aboutus_contactImg__z4mIn","carsubTitle":"Aboutus_carsubTitle__4jocW","testimonialbg":"Aboutus_testimonialbg__5XhGr","cardBody":"Aboutus_cardBody__EZLkF","imgFixedBottom":"Aboutus_imgFixedBottom__y07dZ","viewMore":"Aboutus_viewMore__07zB0","learnText":"Aboutus_learnText__HNqg7","iconSetting":"Aboutus_iconSetting__VWoSo","recongnitionMain":"Aboutus_recongnitionMain__u1JBp","histbg":"Aboutus_histbg__W7Go1"};

/***/ }),

/***/ 65421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arowbt":"history_arowbt__B_mz4","arowbtalign":"history_arowbtalign__KrNDc","hoverClass":"history_hoverClass__9JHAE","hideClass":"history_hideClass__nJzzt","history":"history_history__1T_bP","hstoryContainer":"history_hstoryContainer__MfTkY","containera":"history_containera__QhLJn","container":"history_container__N7FLI","item":"history_item__afdIa","histactive":"history_histactive__Aaq4E","brifHist":"history_brifHist__sg2HN"};

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 49059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 84883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  aspectRatio: '1x1'
};

function toPercent(num) {
  if (num <= 0 || num > 100) return '100%';
  if (num < 1) return `${num * 100}%`;
  return `${num}%`;
}

const Ratio = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  children,
  aspectRatio,
  style,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'ratio');
  const isCustomRatio = typeof aspectRatio === 'number';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    ref: ref,
    ...props,
    style: { ...style,
      ...(isCustomRatio && {
        '--bs-aspect-ratio': toPercent(aspectRatio)
      })
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(bsPrefix, className, !isCustomRatio && `${bsPrefix}-${aspectRatio}`),
    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children)
  });
});
Ratio.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Ratio);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,5655,4706,474,2995,9774,2888,179], function() { return __webpack_exec__(73073); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);